import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';
import {ParticleService} from '@core/services/particle.service';
import {getViewType, ParticleState} from '@shared/store/reducers/particle.reduer';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogService} from '@shared/services/dialog-service';
import {take, takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {DownloadFilingFormErrorReportDownloadCommand, FillingManagerFormExportCommand, FormAttachmentToFilingTaskCommand, SaveFormFieldCommand, SetExportFormSelectedItemCommand} from '../../commands/dac6-reporter.command';
import {DynamicFieldItem} from '@shared/components/dynamic-form/dynamic-form-item';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {StartDataSurveyFromTemplateCommand} from '@shared/commands/shared.commands';
import {SocketClusterService} from '@core/services/socket-cluster.service';
import {
  ExcelExportSourceFileDownloadAction, FillingManagerFormExportAction
} from '../../store/actions/dac6-reporter.actions';
import {SetViewTypeAction} from '@shared/store/actions/particle.actions';
import {Guid} from 'guid-typescript';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {QueryModel} from '@shared/models/query-model';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {ParticleCacheModel} from '@shared/models/particle-cache.model';
import {DialogModel} from '@shared/models/dialog.model';
import { MatDialog } from '@angular/material/dialog';
import {FileDialogComponent} from '../../../file-manager/component/file-dialog/file-dialog.component';
import {FilingErrorReportComponent} from '../filing-error-report/filing-error-report.component';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {FileManagementService} from '@core/services/file-management.service';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import {TaskManagerService} from '../../../task-manager/services/task-manager.service';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {TransmitFileCommand} from '../transmissions/commands/transmission.command';
import {FieldStatus, FieldStatusStyle} from '@shared/constants/common-field.constants';
import {
  SetCurrentFormOverviewAction,
  SetCurrentRightSideComponentAction
} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {IFormState} from "@shared/store/form/form-reducer";
import {IsEditingCompleteInFilingForm} from "@shared/store/form/form-actions";
import {getEditingStatusFilingForm} from "@shared/store/form/form-selectors";
import {DownloadType, FieldefinitionDataType} from "../../Fields";
import { NotificationMessageModel } from '@shared/models/notification-message.model';

@Component({
    standalone: false,
    selector: 'particle-filing-form',
  templateUrl: './filing-form.component.html',
  styleUrls: ['./filing-form.component.scss']
})
export class FilingFormComponent implements OnInit , OnDestroy {

  sourceType: string;
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  unSubscribe$ = new Subject<void>();
  hasNoExtraTab = true;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  selectedFieldSectionIndex: number;
  formId: any;
  breadcrumbKey: string;
  endpointName: string;
  isProjectSpecific: boolean;
  showOriginal: boolean;
  autoSave: boolean;
  showDelete: boolean;
  showLanguageOption: boolean;
  ngUnsubscribe$ = new Subject<void>();
  item$: Observable<any>;
  item: any;
  formFieldsErrorInformation: any;
  formFieldsValidationState: any;
  isDirty: boolean;
  editedFields: string[] = [];
  saveButtonCaption: string;
  containerClass: string;
  formField: DynamicFieldItem;
  formState$: any;
  unsubscibes$ = new Subject<void>();
  fieldConfig: any;
  totalChanges: number = 0;
  autoSaveInterval;
  transmitToAuthority: boolean;
  private hasSubscribedToSocketCluster: boolean;
  viewType: string;
  actions: any[];
  changedValuesFieldDefination = [];
  private queryModels: QueryModel[] = [];
  private exportFormHtmlData: string;
  private executionId: string;
  public rightElementsCount: any;
  private filingExportOptions: any;
  private fileManagerFormExportActivityCommand: PlatformCommand;
  constructor(  private router: Router,
                private store: Store<IDac6ReporterState>,
                private formStore: Store<IFormState>,
                private particleService: ParticleService,
                private taskManagerService: TaskManagerService,
                private particleStore: Store<ParticleState>,
                protected commandService: CommandService,
                private activatedRoute: ActivatedRoute,
                private fuseSplashScreenService: FuseSplashScreenService,
                private snackBarService: SnackBarService,
                private dialogService: DialogService,
                private dac6ApiService: Dac6ReporterApiService,
                private dialog: MatDialog,
                private fileManagementService: FileManagementService,
                private queryState: Store<IQueryState>,
                private socketClusterService: SocketClusterService,
                private particleCacheService: ParticleCacheService,
                private platformSidebarStore: Store<PlatformSidebarState>
  ) {
    this.saveButtonCaption = 'Save';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id : 'forms',
        title: 'Forms',
        type: 'forms',
        relativeUrl: 'dac6-reporter/filing-manager/forms',
        children: []
      }
    ];
    this.selectedFieldSectionIndex = 0;
    this.autoSave = false;
    this.breadcrumbKey = 'BreadcrumbByFormId';
    this.endpointName = 'Dac6Api';
    this.isProjectSpecific = false;
    this.showOriginal = false;
    this.showLanguageOption = true;
    this.invalidateSubject = new InvalidateSubject();
    this.containerClass = 'content';
    // this.formFieldsErrorInformation = {};
  }

  async canDeactivate() {
    let res = true;
    if (this.editedFields.length > 0) {
      const question = 'You have unsaved changes. Do you want to save these changes before continuing?';
      const dialogRef = this.dialogService.showConfirmDialog('Unsaved Changes', 'Yes', 'No', null, question);
      dialogRef.pipe(takeUntil(this.unsubscibes$)).subscribe(data => {
        if (data.action === 'OK') {
          this.save();
          res = false;
        } else if (data.action === 'Closed') {
          res = false;
        }
      });
      await dialogRef.toPromise();
    }
    return res;
  }

  ngOnInit() {
    this.actions = [
      {
        text: 'Export',
        doAction: this.export,
        self: this
      }
    ];
    this.invalidateSubject.getObservale().pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
      if (state.indexOf('SaveChangesOnPageChangeOrTab') >= 0) {
        if (this.editedFields.length > 0) {this.save(); }
      } else if (state.indexOf('AddSectionOrDeleteSection') >= 0) {
        this.save();
      }
    });
    this.activatedRoute.params.pipe(takeUntil(this.unSubscribe$)).subscribe((params: any) => {
      this.formId = params.formId;
      this.queryModels.push(QueryProvider.getQuery(this.breadcrumbKey));
      this.breadcrumbs$ = this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
        if (state) {
          this.breadcrumbs = state.breadcrumb;
        }
      });
      QueryProvider.invokeQuery(this.store, this.breadcrumbKey, {'[ID]': this.formId});
      this.subscribeToSocketCluster(this.formId);
      this.queryModels.push(QueryProvider.getQuery('FormRowById'));
      this.item$ = this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, 'FormRowById'));
      this.item$.subscribe(item => {
        if (item && item.cells) {
          console.log('form row id:', item);
          if (!this.item) {
            this.item = item;
          }
          if (this.item && this.item.id !== item.id) {
            this.item = item;
          }
          Object.keys(item.cells).forEach(key => {
            if (!this.item.cells[key]) {
              this.item.cells[key] = {};
            }
            this.item.cells[key].isDirty = false;
            this.item.cells[key].actualValue = item.cells[key].value;
            this.item.cells[key].value = item.cells[key].value;
            this.item.cells[key].displayText = item.cells[key].displayText;
          });
          this.editedFields.splice(0, this.editedFields.length);
          this.isDirty = false;
          this.sourceType = this.item.cells['FormSourceType'].value;
          if (this.sourceType) {
            const countryCode = this.item.cells['CountryCode'].value;
            if (countryCode) {
              const formViewItem = { 'code': countryCode, 'querykey': 'Dac6FormOverview'};
              this.platformSidebarStore.dispatch(new SetCurrentFormOverviewAction(formViewItem));
            }
          }

          if (!this.formState$) {
            this.getFormFieldConfiguration();
          } else {
            this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
          }
          QueryProvider.invokeQuery(this.store, 'GetFilingOptionsConfig', {'[CODE]': this.item.cells['CountryCode'].value, '[SOURCE_TYPE]': this.item.cells['FormSourceType'].value});
          this.dac6ApiService.getAllHeaderSectionsFormFieldsErrorInformation(this.formId).subscribe(response => {
            if (response) {
              this.formFieldsErrorInformation = {};
              response.forEach(item => this.formFieldsErrorInformation[item.headerSectionKey + '__' + item.formId] = item);
              this.setFieldValidation(response);
              this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
            }
          });
        }
      });
      QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
    });

    this.autoSaveInterval = setInterval( () => {
      if (this.isDirty && this.autoSave) {
        this.save();
      }
    }, 30000);

    this.particleStore.pipe(select(getViewType)).pipe(takeUntil(this.unsubscibes$)).subscribe(viewType => {
      this.viewType = viewType;
    });
    this.store.pipe(takeUntil(this.unSubscribe$), select(getQueryResponse, 'GetFilingOptionsConfig')).subscribe(options => {
      if (options) {
        this.filingExportOptions = options;
      }
    });
    this.platformSidebarStore.dispatch(
      new SetCurrentRightSideComponentAction(
        {component: 'FormOverViewComponent', data: {isUserAction: false}, componentInfo: {id: 'FormOverViewComponent'}}));
    /*this.formStore.pipe(select(getEditingStatusFilingForm)).pipe(takeUntil(this.unSubscribe$)).subscribe(response => {
     if (response) {
     QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
     this.formStore.dispatch(new IsEditingCompleteInFilingForm(false));
     }
     });*/
  }

  viewTypeChanged($event) {
    this.particleStore.dispatch(new SetViewTypeAction($event));
  }

  compactViewType() {
    this.particleStore.dispatch(new SetViewTypeAction('Compact'));
  }

  private getFormFieldConfiguration() {
    const formQueryKey = 'DynamicFormKey';
    const formQuery = {...QueryProvider.getQuery(formQueryKey)};
    formQuery.key = formQueryKey + this.sourceType;
    formQuery.api = this.endpointName;
    let formFieldCache = this.particleCacheService.getItem(formQuery.key);
    if (!formFieldCache || formFieldCache.version !== this.particleCacheService.getClientConfigVersion()) {
      QueryProvider.addConfig(formQuery.key, formQuery);
      this.formState$ = this.queryState.pipe(select(getQueryResponse, formQuery.key)).pipe(take(2));
      this.formState$.pipe(takeUntil(this.unsubscibes$)).subscribe(formState => {
        if (formState) {
          formFieldCache = new ParticleCacheModel();
          formFieldCache.version = this.particleCacheService.getClientConfigVersion();
          formFieldCache.value = formState;
          this.particleCacheService.saveItem(formQuery.key, formFieldCache);
          this.updateFormField(formState);
        }
      });
      QueryProvider.invokeQuery(this.queryState, formQuery.key, {'[SOURCE_TYPE]': this.sourceType});
    } else {
      this.updateFormField(formFieldCache.value);
    }
  }

  private updateFormField(formState) {
    this.formField = formState.formField;
    if (this.formField.viewType === 'Tab') {
      this.containerClass = 'content';
    } else {
      this.containerClass = 'content m-30';
    }
    this.fieldConfig = formState.fieldConfig;
    this.showLanguageOption = this.formField.hasLanguageOption;
    this.showOriginal = this.formField.defaultShowOriginalLanguage;
    this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
  }

  private invalidateLanguage() {
    this.invalidateSubject.invalidate(this.showOriginal ? 'Original' : 'Translated');
  }

  onValueChanged(event) {
    console.log(this.editedFields);
    const exist = this.changedValuesFieldDefination.find( o => o.key === event.event.fieldDefinition.key);
    if (!exist) {
      this.changedValuesFieldDefination.push(event.event.fieldDefinition);
    }
    if (event && event.action === 'ValueChanged') {
      this.totalChanges += event.increment;
      this.dirtyChanged();
    }
  }
  private dirtyChanged() {
    if (this.totalChanges) {
      this.saveButtonCaption = `Save`;
      this.isDirty = true;
    } else {
      this.saveButtonCaption = `Save`;
      this.isDirty = false;
    }
  }
  startDataSurvey() {
    const title = this.item.cells['FormTitle'].value;
    const caseId = this.item.cells['CaseId'].value;
    this.dialogService.showAddSurveyDialog(`${caseId}-${title}`).pipe(takeUntil(this.unsubscibes$))
      .subscribe((res: any) => {
        if (res && res.action == 'OK') {
          console.log(res);
          const collaborativeTemplateId = 'collaborative-dac6-form';
          const individualTemplateId = 'individual-dac6-form';
          const surveyTemplateId = res.data.input.isIndividualResponse ? individualTemplateId : collaborativeTemplateId;
          // const command = new StartDataSurveyFromTemplateCommand(this.item.id,
          //   surveyTemplateId,
          //   res.data.input.title,
          //   res.data.input.description,
          //   caseId
          // );
          const command = new PlatformCommand('CreateTaxFormSurveyCommand', 'DataSurveyApi');
          command.fieldValues['TemplateId'] = surveyTemplateId;
          command.fieldValues['ItemId'] = this.item.id;
          command.fieldValues['SurveyTitle'] = res.data.input.title;
          command.fieldValues['Description'] = res.data.input.description;

          this.fuseSplashScreenService.show();
          this.commandService.executePlatformCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(state => {
            console.log('StartDataSurveyFromTemplateCommand returned ', state);
            this.fuseSplashScreenService.hide();
            if (state && state.fieldValues && state.fieldValues['RedirectUrl']) {
              this.router.navigateByUrl(state.fieldValues['RedirectUrl']);
            }
          }, error => {
            console.error(error);
            this.fuseSplashScreenService.hide();
          });
        }
      });
  }
  exportAndTransmit() {
    this.showExportFilingDialog(true);
  }
  openTransmitFillingDialoge(exportCommandResopnse) {
    if (exportCommandResopnse.Payload &&
      exportCommandResopnse.Payload.MetaData &&
      exportCommandResopnse.Payload.MetaData.transmitKey &&
      exportCommandResopnse.Payload.MetaData.transmitKey.length > 0) {
      const transmitKey = exportCommandResopnse.Payload.MetaData.transmitKey;
      this.fuseSplashScreenService.show();
      this.dac6ApiService.getAgreementByCountryCode(this.item.cells['CountryCode'].value).subscribe(response => {
        this.fuseSplashScreenService.hide();
        if (response) {
          const dialogModel: DialogModel = DialogModel.create(
            'Transmit Form(s)',
            'ConfirmTransmissionDialogComponent',
            { data: response }
          );
          dialogModel.okCaption = 'Transmit';
          this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe((item: any) => {
            if (item.action === 'OK') {
              let fieldValues = {};
              if(item &&
                item.data &&
                item.data.input &&
                item.data.input.TransmissionData &&
                item.data.input.TransmissionData.cells) {
                fieldValues = this.getDictionary(item.data.input.TransmissionData.cells);
              }
              const command = new TransmitFileCommand(transmitKey, this.item.cells['CountryCode'].value, fieldValues);
              this.fuseSplashScreenService.show();
              this.commandService.executeCommand(command).subscribe(response => {
                this.fuseSplashScreenService.hide();
                this.router.navigate(['dac6-reporter/transmissions']);
              });
            }
          });
        }
      });
    }
    else {
      const title = this.rightElementsCount == 1 ? 'Transmit Form' : 'Transmit Form(s)';
      const dialogModel: DialogModel = DialogModel.create(
        title,
        'TransmitFormDialogComponent', {onClick: new EventEmitter<any>(), countryCode: this.item.cells['CountryCode'].value}
      );
      dialogModel.okCaption = 'Next';
      this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
        console.log('transmit:', item);
        if (item && item.action === 'OK') {
          this.downloadOrAttachToTask(this.rightElementsCount, exportCommandResopnse);
        }
      });
      dialogModel.input['onClick'].pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
        console.log(item);
        if (item && item.type === 'Command') {
          this.showDownloadDialog(this.rightElementsCount, exportCommandResopnse);
        }
      });
    }
  }
  getDictionary(dict: any) {
    const ret = {};
    for (const key in dict) {
      ret[key] = dict[key].value;
    }
    return ret;
  }
  ngOnDestroy(): void {
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    if (this.hasSubscribedToSocketCluster && this.formId) {
      this.socketClusterService.unsubscribeChannel(this.formId);
    }
    this.queryModels.forEach(q => {
      this.queryState.dispatch(new DeleteQueryAction(q, null, null));
    });
  }

  export() {
    // TODO : add later
    const command = new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, '', '', false, '', false);
    this.store.dispatch(new FillingManagerFormExportAction(command));
  }
  autoSaveChanged() {
    this.save();
  }
  private subscribeToSocketCluster(itemId) {
    if (!this.hasSubscribedToSocketCluster) {
      this.socketClusterService.subscribeToChannel(itemId, function(notification) {
        console.log('Notification received for item ' + itemId, notification);
        QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
      }.bind(this));
      this.hasSubscribedToSocketCluster = true;
    }

  }
  save() {
    if (this.editedFields.length) {
      const item = {};
      item['id'] = this.item.id;
      item['itemId'] = this.item.itemId;
      item['sourceItemId'] = this.item.sourceItemId;
      item['fieldValues'] = {};
      this.editedFields.forEach(fieldKey => {
        if (this.item.cells[fieldKey]) {
          item['fieldValues'][fieldKey] = this.item.cells[fieldKey].value;
          const fieldDef = this.changedValuesFieldDefination.find( o => o.key === fieldKey);
          if (fieldDef && fieldDef.dataType === FieldefinitionDataType.Attachment && this.item.cells['fileName']) {
            item['fieldValues'][`${fieldKey}FileName`] = this.item.cells['fileName'];
          }
        }
      });
      const command = new SaveFormFieldCommand(this.endpointName, item);
      this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
        this.totalChanges = 0;
        this.dirtyChanged();
        this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
        QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
      });
    } else {
      QueryProvider.invokeQuery(this.store, 'FormRowById', {'[ID]': this.formId});
    }
  }

  onDropDownSelectionChanged($event: BreadcrumbModel) {
    if (!$event) {
      return;
    }
    if ($event.id === this.formId) {
      return;
    }
    this.breadcrumbs[2].id = $event.id;
    this.breadcrumbs[2].title = $event.title;
    this.breadcrumbs[2].relativeUrl = $event.relativeUrl;    this.formId = $event.id;
    this.formId = $event.id;
    this.item = undefined;
    this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
    this.router.navigateByUrl(this.breadcrumbs[2].relativeUrl);
  }

  showOriginalChanged() {
    this.invalidateLanguage();
  }

  showExportFilingDialog( transmitToAuthority = false) {
    this.executionId = Guid.create().toString();
    this.transmitToAuthority = transmitToAuthority;
    this.commandService.executeCommand(new SetExportFormSelectedItemCommand(this.formId, this.executionId));
    const input = {
      'FORM_TEMPLATE_ID': this.item ? this.item.cells ? this.item.cells['FormTemplateId'] ? this.item.cells['FormTemplateId'].value : '' : '' : ''
    };
    const dialogModel = DialogModel.create('Select Form(s)', 'EntitySelectorDialogComponent', {
      filterId: this.executionId,
      filterTemplateId: 'dac6-export-forms-filter',
      apiKey: 'Dac6Api',
      input: input
    });
    dialogModel.minWidth = '1024px';
    dialogModel.maxWidth = '1024px';
    dialogModel.okCaption = 'Next';

    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          this.rightElementsCount = actionState.data.input.rightElementsCount;
          this.handleDownloadNextAction();
        }

      });
  }
  async handleDownloadNextAction() {
    if (this.transmitToAuthority) {
      const defaultExportOption = this.getExportDownloadOption();
      if(defaultExportOption.MetaData['HasReferenceTitleUi']){
        const dialogModel = DialogModel.create('Export Report', 'MxHallmarkReportExportInputDialogComponent', {}, '600px', '600px');
        this.dialogService.showOkCancelDialog(dialogModel).subscribe(state=>{
          this.fuseSplashScreenService.show();
          const command = new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, this.executionId, defaultExportOption.DownloadType, true, defaultExportOption.MetaData['Process'], !this.showOriginal, dialogModel.input['exportReportInfo']);
          this.commandService.executeCommand(command).subscribe(commandState => {
            if (commandState) {
              this.fuseSplashScreenService.hide();
              if (commandState.Payload.HasError) {
                this.showErrorReportDialog(commandState);
              } else {
                this.openTransmitFillingDialoge(commandState);
              }
            }
          });
        })
      }else{
        this.fuseSplashScreenService.show();
        const command = new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, this.executionId, defaultExportOption.DownloadType, true, defaultExportOption.MetaData['Process'], !this.showOriginal);
        this.commandService.executeCommand(command).subscribe(commandState => {
          if (commandState) {
            this.fuseSplashScreenService.hide();
            if (commandState.Payload.HasError) {
              this.showErrorReportDialog(commandState);
            } else {
              this.openTransmitFillingDialoge(commandState);
            }
          }
        });
      }
    }
    else {
      this.showDownloadDialog(this.rightElementsCount);
    }
  }
  openExportReportReferenceInputDialog(): any{
    const dialogModel = DialogModel.create('Select Form(s)', 'EntitySelectorDialogComponent', {}, '600px', '600px');
  }
  showErrorReportDialog(exportCommandResopnse) {
    const dialogRef = this.dialog.open(FilingErrorReportComponent, {
      minWidth: '750px',
      maxWidth: '850px',
      data: {
        transmitToAuthority: this.transmitToAuthority,
        exectionId: this.executionId,
        formId: this.formId,
        hasError: exportCommandResopnse.Payload.HasError,
        rightElementsCount: this.rightElementsCount,
        countryCode: this.item.cells['CountryCode'].value
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unsubscibes$)).subscribe((result: string) => {
      if (result) {
        switch (result) {
          case 'download-form':
            this.showDownloadDialog(this.rightElementsCount, exportCommandResopnse);
            break;
          case 'transmit-to-authority':
            this.openTransmitFillingDialoge(exportCommandResopnse);
            break;
        }
      }
    });
  }
  showDownloadDialog(selectedItemCount, exportCommandResopnse = null) {
    const dialogModel: DialogModel = DialogModel.create(
      'Download or Save',
      'FilingExportOptionsDialogComponent',
      {
        clickAction: new EventEmitter<any>(),
        selectedItemCount: selectedItemCount,
        countryCode: this.item.cells['CountryCode'].value,
        options: this.filingExportOptions,
        transmission: this.transmitToAuthority
      }
    );
    dialogModel.minWidth = '520px';
    dialogModel.maxWidth = '520px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
      console.log(item);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unsubscibes$)).subscribe(option => {
      console.log(option);
      if (option.includes('SaveToDrive')) {
        const fileType = option.split('-')[1];
        this.saveToDrive(this.executionId, fileType, dialogModel.input['ExportOption']);
      } else {
        this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse);
      }
    });
  }
  downloadForm(option: string, exportOption, exportCommandResponse) {
    if (!exportCommandResponse) {
      if(exportOption.MetaData['HasReferenceTitleUi']){
        const dialogModel = DialogModel.create('Export Report', 'MxHallmarkReportExportInputDialogComponent', {}, '600px', '600px');
        this.dialogService.showOkCancelDialog(dialogModel).subscribe(state=>{
          const command = new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, this.executionId, option, false, exportOption.MetaData['Process'], !this.showOriginal, dialogModel.input['exportReportInfo']);
          this.fuseSplashScreenService.show();
          this.commandService.executeCommand(command).subscribe(commandState => {
            if (commandState) {
              this.fuseSplashScreenService.hide();

              this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
                this.executionId, exportOption.MetaData['Process']);

              this.store.dispatch(new ExcelExportSourceFileDownloadAction(commandState.Payload));
              this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
            }
          });
        })
      }
      else{
        const command = new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, this.executionId, option, false, exportOption.MetaData['Process'], !this.showOriginal);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(commandState => {
          if (commandState) {
            this.fuseSplashScreenService.hide();

            this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
              this.executionId, exportOption.MetaData['Process']);


            this.store.dispatch(new ExcelExportSourceFileDownloadAction(commandState.Payload));
            this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
          }
        });
      }
    } else {
      this.store.dispatch(new ExcelExportSourceFileDownloadAction(exportCommandResponse.Payload));
      this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(exportCommandResponse,
        this.executionId, exportOption.MetaData['Process']);
      this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);
    }
  }
  saveToDrive(executionId: string, fileType: string, exportOption) {
    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        itemsUrlIndex: 1,
        type: 'SharedDrives',
        folderId: '',
        driveId: '',
        isFileSelector: false,
        viewType: 'TeamDrive',
        title: 'Select Folder'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: any) => {
      const selectedFolderInfo = result;
      if (selectedFolderInfo && selectedFolderInfo !== '') {
        const parentId = selectedFolderInfo.id;
        const driveId = selectedFolderInfo.cells.ItemId.value;
        const command = new FillingManagerFormExportCommand(this.item.cells['CountryCode'].value, this.formId, executionId, fileType, false, exportOption.MetaData['Process'], this.showOriginal, {}, parentId, driveId, true);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe((commandState) => {
          this.fuseSplashScreenService.hide();

          this.fileManagerFormExportActivityCommand = this.generateFileMangerExportActivityCommand(commandState,
            this.executionId, exportOption.MetaData['Process']);

          this.commandService.executePlatformCommand(this.fileManagerFormExportActivityCommand);

          this.snackBarService.showInformation('Form(s) are saved to drive successfully.');
        });
      }
    });
  }
  //#region "Unused Region"
  cleanUpSelections(executionId) {
    // TODO: will implement later
  }
  //#endregion

  downloadOrAttachToTask(selectedItemCount, exportCommandResopnse) {
    const dialogModel: DialogModel = DialogModel.create(
      'Download or Attach to Task',
      'FilingDownloadOrAttachmentToTaskComponent',
      {
        clickAction: new EventEmitter<any>(),
        selectedItemCount: selectedItemCount,
        countryCode: this.item.cells['CountryCode'].value,
        options: this.filingExportOptions,
        transmission: this.transmitToAuthority
      }
    );
    dialogModel.minWidth = '520px';
    dialogModel.maxWidth = '520px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
      console.log(item);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unsubscibes$)).subscribe(option => {
      console.log(option);
      if (option.includes('AttachtoTask')) {
        const fileType = option.split('-')[1];
        this.attachToTask(fileType, dialogModel.input['ExportOption'], exportCommandResopnse);
      } else {
        this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse);
      }
    });
  }

  private attachToTask(fileType: string, exportOption, exportCommandResopnse = null) {
    /*    if(!exportCommandResopnse){
     const command = new FillingManagerFormExportCommand(this.formId, this.executionId, fileType, false);
     this.fuseSplashScreenService.show();
     this.commandService.executeCommand(command).subscribe(commandState =>{
     if(commandState){
     this.fuseSplashScreenService.hide();
     console.log('whats inside', commandState.Payload);
     this.attach(commandState.Payload.FileId, fileType);
     }
     });
     } else{
     console.log('whats inside not', exportCommandResopnse.Payload);
     this.attach(exportCommandResopnse.Payload.FileId, fileType);
     }*/

    this.attach(this.formId, this.executionId, fileType, exportOption);
  }

  private attach(formId: any, executionId: any, fileType: any, exportOption: any) {
    if ( exportOption.DownloadType === DownloadType.fvie ) {
      exportOption = this.filingExportOptions.ExportOptions.find(option => option.DownloadType === DownloadType.XML );
      fileType = DownloadType.XML;
    }
    const countryCode = this.item.cells['CountryCode'].value;
    const taskDetails = this.item.cells['DAC6FilingStatus'].value;
    const caseId = this.item.cells['CaseId'].value;
    const fileName = `${caseId}${countryCode}.${fileType}`;
    const command = new FormAttachmentToFilingTaskCommand(countryCode, formId, executionId, fileType, 'Dac6-Filling', exportOption.MetaData['Process']);
    command.scope = ContentScope.Company;
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(data => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showInformation('Attachment added successfully.');
      if (data && data.Payload) {
        this.taskManagerService.openTaskByTaskId(data.Payload.Id, GraphqlContentScope.getScope(data.Payload.Scope));
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError(err.Payload);
    });
  }

  private setFieldValidation(response: any) {
    this.formFieldsValidationState = {};
    response.forEach(item => {
      if (item.validateModels) {
        item.validateModels.forEach(model => {
          this.updateFieldValidationStatus(model);
        });
      }
    });
  }

  private updateFieldValidationStatus(model: any) {
    switch (model.fieldStatus) {
      case 0:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'Yes',
          errorMessage: model.message
        };
        break;
      case 1:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'Yes',
          errorMessage: model.message
        };
        break;
      case 2:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'No',
          errorMessage: model.message
        };
        break;
      case 3:
        this.formFieldsValidationState[model.formId + '__' + model.fieldKey] = {
          isValid: 'No',
          errorMessage: model.message
        };
        break;
    }
  }

  private getExportDownloadOption() {
    let downloadType = this.filingExportOptions.DefaultDownloadType;
    let selectedExportOption;
    if(this.rightElementsCount > 1){
      let hasMergedItems = false;
      this.filingExportOptions.ExportOptions.forEach(item=>{
        if(item.IsMerge){
          hasMergedItems = true;
        }
      });
      if( hasMergedItems ) downloadType = DownloadType.XML;
      else if( downloadType !== DownloadType.fvie ) downloadType = DownloadType.ZIP;
    }
    else {
      if ( downloadType === DownloadType.ZIP ) downloadType = DownloadType.XML;
    }
    selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    if(!selectedExportOption){
      downloadType = this.filingExportOptions.DefaultDownloadType;
      selectedExportOption = this.filingExportOptions.ExportOptions.find(option=>option.DownloadType === downloadType);
    }
    return selectedExportOption;
  }
  onFieldSelectionChanged(event){
    if(event.metaData && event.metaData['DirectoryPath']){
      const caseId = this.item.cells['CaseId'].value;
      event.metaData['DirectoryPath'] = event.metaData['DirectoryPath'].replace('[CASE_ID]' ,caseId );
    }
  }

  generateFileMangerExportActivityCommand(response: NotificationMessageModel, executionId: string, process: string): PlatformCommand{
    const command = new PlatformCommand("ExportFormActivityCommand", "DAC6Api");

    command.fieldValues["FileName"] = response.Payload.FileName;
    command.fieldValues["FileId"] = response.Payload.FileId;
    command.fieldValues["Process"] = process;
    command.fieldValues["ExecutionId"] = executionId;

    return command;
  }
}
